// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/device.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { DeviceAssignment, DeviceIntegrity, DeviceStatus } from "../../common/v1/common_pb.js";
import { file_console_common_v1_common } from "../../common/v1/common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/device.proto.
 */
export const file_console_admin_v1_device: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_console_common_v1_common]);

/**
 * @generated from message console.admin.v1.Device
 */
export type Device = Message<"console.admin.v1.Device"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: console.common.v1.DeviceAssignment assignment = 3;
   */
  assignment: DeviceAssignment;

  /**
   * @generated from field: string soti_device_id = 4;
   */
  sotiDeviceId: string;

  /**
   * The app-readable stable identifier the tablet registered with: its identity.
   *
   * @generated from field: string hardware_id = 13;
   */
  hardwareId: string;

  /**
   * The unit serial the tablet last reported that was not empty, for people
   * to match it to its label. Self-reported; the device's identity is
   * `hardware_id`. Empty when it never reported one.
   *
   * @generated from field: string serial = 17;
   */
  serial: string;

  /**
   * @generated from field: console.common.v1.DeviceStatus status = 14;
   */
  status: DeviceStatus;

  /**
   * Why it is not active, for the console; the audit event has the actor.
   *
   * @generated from field: string status_note = 15;
   */
  statusNote: string;

  /**
   * @generated from field: google.protobuf.Timestamp status_changed_at = 16;
   */
  statusChangedAt?: Timestamp | undefined;

  /**
   * @generated from field: string model = 5;
   */
  model: string;

  /**
   * @generated from field: string app_version = 6;
   */
  appVersion: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_seen = 7;
   */
  firstSeen?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_seen = 8;
   */
  lastSeen?: Timestamp | undefined;

  /**
   * Last successful ReportEvents or Heartbeat.
   *
   * @generated from field: google.protobuf.Timestamp last_sync_at = 9;
   */
  lastSyncAt?: Timestamp | undefined;

  /**
   * @generated from field: uint32 outbox_depth = 10;
   */
  outboxDepth: number;

  /**
   * Generation of the current key in the last keyring this device fetched.
   * Empty for anyone but MotionSafe staff.
   *
   * @generated from field: string keyring_generation = 11;
   */
  keyringGeneration: string;

  /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 12;
   */
  revokedAt?: Timestamp | undefined;

  /**
   * When and by whom the device was assigned; empty while it waits.
   *
   * @generated from field: google.protobuf.Timestamp assigned_at = 18;
   */
  assignedAt?: Timestamp | undefined;

  /**
   * @generated from field: string assigned_by = 19;
   */
  assignedBy: string;

  /**
   * @generated from field: string assignment_note = 20;
   */
  assignmentNote: string;

  /**
   * Set on a registration that gave a hardware id a device on record holds:
   * that device, its status, its organization and its assignment, as they are
   * now. Assigning the registration (the device it replaces is unassigned) or
   * approving it (ApproveDeviceTakeover, the device it replaces is assigned)
   * revokes that device as replaced.
   *
   * @generated from field: string replaces_device_id = 21;
   */
  replacesDeviceId: string;

  /**
   * @generated from field: console.common.v1.DeviceStatus replaces_status = 22;
   */
  replacesStatus: DeviceStatus;

  /**
   * @generated from field: string replaces_org_id = 23;
   */
  replacesOrgId: string;

  /**
   * @generated from field: console.common.v1.DeviceAssignment replaces_assignment = 31;
   */
  replacesAssignment: DeviceAssignment;

  /**
   * Given to another organization, and the device has yet to be told.
   *
   * @generated from field: bool move_pending = 24;
   */
  movePending: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp moved_at = 25;
   */
  movedAt?: Timestamp | undefined;

  /**
   * The organization's own name for the device. It goes when the device
   * leaves the organization.
   *
   * @generated from field: string label = 26;
   */
  label: string;

  /**
   * MotionSafe's own name for the device, kept through moves. Empty for
   * anyone but MotionSafe staff.
   *
   * @generated from field: string staff_label = 27;
   */
  staffLabel: string;

  /**
   * What the device last said about its boot and build, when it said so,
   * and what the console reads in it. Self-reported, so a sign and not a
   * proof. Empty for anyone but MotionSafe staff, and before the device's
   * app reports it.
   *
   * @generated from field: console.common.v1.DeviceIntegrity integrity = 28;
   */
  integrity?: DeviceIntegrity | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp integrity_reported_at = 29;
   */
  integrityReportedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated console.admin.v1.IntegrityFinding integrity_findings = 30;
   */
  integrityFindings: IntegrityFinding[];

  /**
   * When the certificate the device was last given ends. Empty for anyone
   * but MotionSafe staff.
   *
   * @generated from field: google.protobuf.Timestamp mtls_certificate_not_after = 33;
   */
  mtlsCertificateNotAfter?: Timestamp | undefined;

  /**
   * The device's key can sign a TLS handshake, as its last heartbeat said.
   * A device whose key cannot is offered a new one before it is given a
   * certificate. False for anyone but MotionSafe staff.
   *
   * @generated from field: bool mtls_capable = 34;
   */
  mtlsCapable: boolean;

  /**
   * What the device last said of its capabilities (HeartbeatRequest.capabilities), and
   * when. Empty for anyone but MotionSafe staff, and from a device whose
   * platform does not run them.
   *
   * @generated from field: uint64 capabilities_container_version = 35;
   */
  capabilitiesContainerVersion: bigint;

  /**
   * @generated from field: string capabilities_release_id = 36;
   */
  capabilitiesReleaseId: string;

  /**
   * @generated from field: bool capabilities_restart_pending = 37;
   */
  capabilitiesRestartPending: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp capabilities_reported_at = 38;
   */
  capabilitiesReportedAt?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 0);

/**
 * One thing in a device's integrity report that a release tablet in normal
 * use would not show.
 *
 * @generated from message console.admin.v1.IntegrityFinding
 */
export type IntegrityFinding = Message<"console.admin.v1.IntegrityFinding"> & {
  /**
   * @generated from field: console.admin.v1.IntegritySignal signal = 1;
   */
  signal: IntegritySignal;

  /**
   * The tablet is unlocked, rooted, or not a release build. Otherwise a
   * way in has been turned on, which is a warning.
   *
   * @generated from field: bool critical = 2;
   */
  critical: boolean;
};

/**
 * Describes the message console.admin.v1.IntegrityFinding.
 * Use `create(IntegrityFindingSchema)` to create a new message.
 */
export const IntegrityFindingSchema: GenMessage<IntegrityFinding> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 1);

/**
 * @generated from message console.admin.v1.ListDevicesRequest
 */
export type ListDevicesRequest = Message<"console.admin.v1.ListDevicesRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: bool include_revoked = 2;
   */
  includeRevoked: boolean;

  /**
   * @generated from field: console.common.v1.DeviceStatus status = 5;
   */
  status: DeviceStatus;

  /**
   * MotionSafe staff only: the devices that belong to no organization,
   * whatever organization is named: those waiting to be assigned, and
   * those out of circulation.
   *
   * @generated from field: bool awaiting_assignment = 6;
   */
  awaitingAssignment: boolean;

  /**
   * MotionSafe staff only: the devices of every organization, whatever
   * organization is named.
   *
   * @generated from field: bool all_organizations = 7;
   */
  allOrganizations: boolean;

  /**
   * With all_organizations, MotionSafe staff only: the devices that belong to
   * no organization as well, listed before the others. Paged by offset.
   *
   * @generated from field: bool include_unassigned = 12;
   */
  includeUnassigned: boolean;

  /**
   * Devices whose label, staff label, device identifier, model, app version
   * or SOTI ID contains this, in any case.
   *
   * @generated from field: string query = 8;
   */
  query: string;

  /**
   * MotionSafe staff only: devices whose last integrity report shows a
   * finding.
   *
   * @generated from field: bool integrity_findings_only = 9;
   */
  integrityFindingsOnly: boolean;

  /**
   * These devices only, at most 100. Scoped like every other filter.
   *
   * @generated from field: repeated string ids = 10;
   */
  ids: string[];

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;

  /**
   * Rows to skip, for a numbered page. Used in place of `page_token`.
   *
   * @generated from field: uint32 offset = 11;
   */
  offset: number;
};

/**
 * Describes the message console.admin.v1.ListDevicesRequest.
 * Use `create(ListDevicesRequestSchema)` to create a new message.
 */
export const ListDevicesRequestSchema: GenMessage<ListDevicesRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 2);

/**
 * @generated from message console.admin.v1.ListDevicesResponse
 */
export type ListDevicesResponse = Message<"console.admin.v1.ListDevicesResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * How many devices match, across every page.
   *
   * @generated from field: uint32 total = 3;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.ListDevicesResponse.
 * Use `create(ListDevicesResponseSchema)` to create a new message.
 */
export const ListDevicesResponseSchema: GenMessage<ListDevicesResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 3);

/**
 * @generated from message console.admin.v1.CountDevicesRequest
 */
export type CountDevicesRequest = Message<"console.admin.v1.CountDevicesRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * MotionSafe staff only: every device, whatever organization is named,
   * including those that belong to none.
   *
   * @generated from field: bool all_organizations = 2;
   */
  allOrganizations: boolean;
};

/**
 * Describes the message console.admin.v1.CountDevicesRequest.
 * Use `create(CountDevicesRequestSchema)` to create a new message.
 */
export const CountDevicesRequestSchema: GenMessage<CountDevicesRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 4);

/**
 * @generated from message console.admin.v1.CountDevicesResponse
 */
export type CountDevicesResponse = Message<"console.admin.v1.CountDevicesResponse"> & {
  /**
   * Every combination that has a device, once.
   *
   * @generated from field: repeated console.admin.v1.DeviceCount groups = 1;
   */
  groups: DeviceCount[];
};

/**
 * Describes the message console.admin.v1.CountDevicesResponse.
 * Use `create(CountDevicesResponseSchema)` to create a new message.
 */
export const CountDevicesResponseSchema: GenMessage<CountDevicesResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 5);

/**
 * @generated from message console.admin.v1.DeviceCount
 */
export type DeviceCount = Message<"console.admin.v1.DeviceCount"> & {
  /**
   * @generated from field: console.common.v1.DeviceStatus status = 1;
   */
  status: DeviceStatus;

  /**
   * Belongs to no organization: waiting to be assigned, or out of
   * circulation (as ListDevicesRequest.awaiting_assignment).
   *
   * @generated from field: bool unassigned = 2;
   */
  unassigned: boolean;

  /**
   * @generated from field: bool revoked = 3;
   */
  revoked: boolean;

  /**
   * The last integrity report shows a finding. Always false for anyone but
   * MotionSafe staff.
   *
   * @generated from field: bool integrity_findings = 4;
   */
  integrityFindings: boolean;

  /**
   * @generated from field: uint32 devices = 5;
   */
  devices: number;
};

/**
 * Describes the message console.admin.v1.DeviceCount.
 * Use `create(DeviceCountSchema)` to create a new message.
 */
export const DeviceCountSchema: GenMessage<DeviceCount> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 6);

/**
 * @generated from message console.admin.v1.GetDeviceRequest
 */
export type GetDeviceRequest = Message<"console.admin.v1.GetDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message console.admin.v1.GetDeviceRequest.
 * Use `create(GetDeviceRequestSchema)` to create a new message.
 */
export const GetDeviceRequestSchema: GenMessage<GetDeviceRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 7);

/**
 * @generated from message console.admin.v1.GetDeviceResponse
 */
export type GetDeviceResponse = Message<"console.admin.v1.GetDeviceResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.GetDeviceResponse.
 * Use `create(GetDeviceResponseSchema)` to create a new message.
 */
export const GetDeviceResponseSchema: GenMessage<GetDeviceResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 8);

/**
 * @generated from message console.admin.v1.SetDeviceStatusRequest
 */
export type SetDeviceStatusRequest = Message<"console.admin.v1.SetDeviceStatusRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: console.common.v1.DeviceStatus status = 2;
   */
  status: DeviceStatus;

  /**
   * @generated from field: string note = 3;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.SetDeviceStatusRequest.
 * Use `create(SetDeviceStatusRequestSchema)` to create a new message.
 */
export const SetDeviceStatusRequestSchema: GenMessage<SetDeviceStatusRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 9);

/**
 * @generated from message console.admin.v1.SetDeviceStatusResponse
 */
export type SetDeviceStatusResponse = Message<"console.admin.v1.SetDeviceStatusResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.SetDeviceStatusResponse.
 * Use `create(SetDeviceStatusResponseSchema)` to create a new message.
 */
export const SetDeviceStatusResponseSchema: GenMessage<SetDeviceStatusResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 10);

/**
 * @generated from message console.admin.v1.AssignDeviceRequest
 */
export type AssignDeviceRequest = Message<"console.admin.v1.AssignDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * The organization the device is given to.
   *
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string note = 4;
   */
  note: string;

  /**
   * MotionSafe's own name for the device. Left empty, the device keeps the
   * one it has, or takes the one of the device it replaces.
   *
   * @generated from field: string staff_label = 5;
   */
  staffLabel: string;
};

/**
 * Describes the message console.admin.v1.AssignDeviceRequest.
 * Use `create(AssignDeviceRequestSchema)` to create a new message.
 */
export const AssignDeviceRequestSchema: GenMessage<AssignDeviceRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 11);

/**
 * @generated from message console.admin.v1.AssignDeviceResponse
 */
export type AssignDeviceResponse = Message<"console.admin.v1.AssignDeviceResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.AssignDeviceResponse.
 * Use `create(AssignDeviceResponseSchema)` to create a new message.
 */
export const AssignDeviceResponseSchema: GenMessage<AssignDeviceResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 12);

/**
 * @generated from message console.admin.v1.ApproveDeviceTakeoverRequest
 */
export type ApproveDeviceTakeoverRequest = Message<"console.admin.v1.ApproveDeviceTakeoverRequest"> & {
  /**
   * The registration waiting to take over (Device.replaces_device_id is set).
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * The code on the tablet's screen, as typed: case, spaces and the dash
   * between its halves do not matter.
   *
   * @generated from field: string screen_code = 2;
   */
  screenCode: string;
};

/**
 * Describes the message console.admin.v1.ApproveDeviceTakeoverRequest.
 * Use `create(ApproveDeviceTakeoverRequestSchema)` to create a new message.
 */
export const ApproveDeviceTakeoverRequestSchema: GenMessage<ApproveDeviceTakeoverRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 13);

/**
 * @generated from message console.admin.v1.ApproveDeviceTakeoverResponse
 */
export type ApproveDeviceTakeoverResponse = Message<"console.admin.v1.ApproveDeviceTakeoverResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.ApproveDeviceTakeoverResponse.
 * Use `create(ApproveDeviceTakeoverResponseSchema)` to create a new message.
 */
export const ApproveDeviceTakeoverResponseSchema: GenMessage<ApproveDeviceTakeoverResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 14);

/**
 * @generated from message console.admin.v1.MoveDeviceRequest
 */
export type MoveDeviceRequest = Message<"console.admin.v1.MoveDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * The organization the device is given to.
   *
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string note = 3;
   */
  note: string;

  /**
   * MotionSafe's own name for the device. Left empty, the device keeps the
   * one it has.
   *
   * @generated from field: string staff_label = 4;
   */
  staffLabel: string;
};

/**
 * Describes the message console.admin.v1.MoveDeviceRequest.
 * Use `create(MoveDeviceRequestSchema)` to create a new message.
 */
export const MoveDeviceRequestSchema: GenMessage<MoveDeviceRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 15);

/**
 * @generated from message console.admin.v1.MoveDeviceResponse
 */
export type MoveDeviceResponse = Message<"console.admin.v1.MoveDeviceResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.MoveDeviceResponse.
 * Use `create(MoveDeviceResponseSchema)` to create a new message.
 */
export const MoveDeviceResponseSchema: GenMessage<MoveDeviceResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 16);

/**
 * @generated from message console.admin.v1.RevokeDeviceRequest
 */
export type RevokeDeviceRequest = Message<"console.admin.v1.RevokeDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.RevokeDeviceRequest.
 * Use `create(RevokeDeviceRequestSchema)` to create a new message.
 */
export const RevokeDeviceRequestSchema: GenMessage<RevokeDeviceRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 17);

/**
 * @generated from message console.admin.v1.DeleteDeviceRequest
 */
export type DeleteDeviceRequest = Message<"console.admin.v1.DeleteDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message console.admin.v1.DeleteDeviceRequest.
 * Use `create(DeleteDeviceRequestSchema)` to create a new message.
 */
export const DeleteDeviceRequestSchema: GenMessage<DeleteDeviceRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 18);

/**
 * @generated from message console.admin.v1.DeleteDeviceResponse
 */
export type DeleteDeviceResponse = Message<"console.admin.v1.DeleteDeviceResponse"> & {
};

/**
 * Describes the message console.admin.v1.DeleteDeviceResponse.
 * Use `create(DeleteDeviceResponseSchema)` to create a new message.
 */
export const DeleteDeviceResponseSchema: GenMessage<DeleteDeviceResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 19);

/**
 * @generated from message console.admin.v1.RevokeDeviceResponse
 */
export type RevokeDeviceResponse = Message<"console.admin.v1.RevokeDeviceResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.RevokeDeviceResponse.
 * Use `create(RevokeDeviceResponseSchema)` to create a new message.
 */
export const RevokeDeviceResponseSchema: GenMessage<RevokeDeviceResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 20);

/**
 * @generated from message console.admin.v1.SetDeviceLabelRequest
 */
export type SetDeviceLabelRequest = Message<"console.admin.v1.SetDeviceLabelRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message console.admin.v1.SetDeviceLabelRequest.
 * Use `create(SetDeviceLabelRequestSchema)` to create a new message.
 */
export const SetDeviceLabelRequestSchema: GenMessage<SetDeviceLabelRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 21);

/**
 * @generated from message console.admin.v1.SetDeviceLabelResponse
 */
export type SetDeviceLabelResponse = Message<"console.admin.v1.SetDeviceLabelResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.SetDeviceLabelResponse.
 * Use `create(SetDeviceLabelResponseSchema)` to create a new message.
 */
export const SetDeviceLabelResponseSchema: GenMessage<SetDeviceLabelResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 22);

/**
 * @generated from message console.admin.v1.SetDeviceStaffLabelRequest
 */
export type SetDeviceStaffLabelRequest = Message<"console.admin.v1.SetDeviceStaffLabelRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string staff_label = 2;
   */
  staffLabel: string;
};

/**
 * Describes the message console.admin.v1.SetDeviceStaffLabelRequest.
 * Use `create(SetDeviceStaffLabelRequestSchema)` to create a new message.
 */
export const SetDeviceStaffLabelRequestSchema: GenMessage<SetDeviceStaffLabelRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 23);

/**
 * @generated from message console.admin.v1.SetDeviceStaffLabelResponse
 */
export type SetDeviceStaffLabelResponse = Message<"console.admin.v1.SetDeviceStaffLabelResponse"> & {
  /**
   * @generated from field: console.admin.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message console.admin.v1.SetDeviceStaffLabelResponse.
 * Use `create(SetDeviceStaffLabelResponseSchema)` to create a new message.
 */
export const SetDeviceStaffLabelResponseSchema: GenMessage<SetDeviceStaffLabelResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_device, 24);

/**
 * @generated from enum console.admin.v1.IntegritySignal
 */
export enum IntegritySignal {
  /**
   * @generated from enum value: INTEGRITY_SIGNAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTEGRITY_SIGNAL_BOOTLOADER_UNLOCKED = 1;
   */
  BOOTLOADER_UNLOCKED = 1,

  /**
   * Verified boot is not green: the system it booted is not the one its
   * maker signed.
   *
   * @generated from enum value: INTEGRITY_SIGNAL_VERIFIED_BOOT = 2;
   */
  VERIFIED_BOOT = 2,

  /**
   * @generated from enum value: INTEGRITY_SIGNAL_ROOT_TRACES = 3;
   */
  ROOT_TRACES = 3,

  /**
   * A userdebug or eng build, or one that lets any app be debugged.
   *
   * @generated from enum value: INTEGRITY_SIGNAL_DEBUGGABLE_BUILD = 4;
   */
  DEBUGGABLE_BUILD = 4,

  /**
   * @generated from enum value: INTEGRITY_SIGNAL_TEST_KEYS = 5;
   */
  TEST_KEYS = 5,

  /**
   * @generated from enum value: INTEGRITY_SIGNAL_DEVELOPER_OPTIONS = 6;
   */
  DEVELOPER_OPTIONS = 6,

  /**
   * @generated from enum value: INTEGRITY_SIGNAL_USB_DEBUGGING = 7;
   */
  USB_DEBUGGING = 7,

  /**
   * @generated from enum value: INTEGRITY_SIGNAL_WIRELESS_DEBUGGING = 8;
   */
  WIRELESS_DEBUGGING = 8,
}

/**
 * Describes the enum console.admin.v1.IntegritySignal.
 */
export const IntegritySignalSchema: GenEnum<IntegritySignal> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_device, 0);

/**
 * Registered tablets, as the console sees them. Devices do not consume seats;
 * they exist so a lost or retired tablet can be revoked and so the console can
 * show when each last synced.
 *
 * @generated from service console.admin.v1.DeviceService
 */
export const DeviceService: GenService<{
  /**
   * @generated from rpc console.admin.v1.DeviceService.ListDevices
   */
  listDevices: {
    methodKind: "unary";
    input: typeof ListDevicesRequestSchema;
    output: typeof ListDevicesResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.DeviceService.GetDevice
   */
  getDevice: {
    methodKind: "unary";
    input: typeof GetDeviceRequestSchema;
    output: typeof GetDeviceResponseSchema;
  },
  /**
   * How many devices there are, in groups a page sums as it needs: its
   * counts and the numbers on its filters, without listing the devices.
   *
   * @generated from rpc console.admin.v1.DeviceService.CountDevices
   */
  countDevices: {
    methodKind: "unary";
    input: typeof CountDevicesRequestSchema;
    output: typeof CountDevicesResponseSchema;
  },
  /**
   * MotionSafe staff only. Suspend (reversible), mark unsupported
   * (reversible), reinstate, or revoke (permanent). Every session on the device ends at its next
   * contact for anything but ACTIVE; a revoked key cannot register again.
   *
   * @generated from rpc console.admin.v1.DeviceService.SetDeviceStatus
   */
  setDeviceStatus: {
    methodKind: "unary";
    input: typeof SetDeviceStatusRequestSchema;
    output: typeof SetDeviceStatusResponseSchema;
  },
  /**
   * MotionSafe staff only. Assigns a device to an organization, by its
   * hardware id. A device that belongs to an organization already is given
   * to another with MoveDevice.
   *
   * @generated from rpc console.admin.v1.DeviceService.AssignDevice
   */
  assignDevice: {
    methodKind: "unary";
    input: typeof AssignDeviceRequestSchema;
    output: typeof AssignDeviceResponseSchema;
  },
  /**
   * MotionSafe staff only. Gives an assigned device to another organization,
   * or puts one that is out of circulation back into use with one: set up
   * and tried under the staff organization, then handed to the customer. Every session on it
   * ends, and the device clears what the last organization left on it
   * (sessions, PINs, remembered addresses, keys) at its next contact. Only
   * the new organization's people sign in on it from then on.
   *
   * @generated from rpc console.admin.v1.DeviceService.MoveDevice
   */
  moveDevice: {
    methodKind: "unary";
    input: typeof MoveDeviceRequestSchema;
    output: typeof MoveDeviceResponseSchema;
  },
  /**
   * MotionSafe staff only. A tablet whose app was reset registers again with
   * a new key under the hardware id an assigned device holds, and waits:
   * nobody signs in on it until staff approve it here, with the code its
   * screen shows. The code is made from the registration's own key, so it
   * ties the approval to the tablet in hand, which the hardware id cannot.
   * The registration then takes the device's place (its organization, status
   * and labels), and the device it replaces is revoked as replaced, with its
   * sessions.
   *
   * @generated from rpc console.admin.v1.DeviceService.ApproveDeviceTakeover
   */
  approveDeviceTakeover: {
    methodKind: "unary";
    input: typeof ApproveDeviceTakeoverRequestSchema;
    output: typeof ApproveDeviceTakeoverResponseSchema;
  },
  /**
   * Kept for the permanent case; equivalent to SetDeviceStatus REVOKED.
   *
   * @generated from rpc console.admin.v1.DeviceService.RevokeDevice
   */
  revokeDevice: {
    methodKind: "unary";
    input: typeof RevokeDeviceRequestSchema;
    output: typeof RevokeDeviceResponseSchema;
  },
  /**
   * MotionSafe admins only. Removes a device that belongs to no organization
   * from the record: a registration nobody assigned, or a device out of
   * circulation. A tablet that is still in use registers again when its app
   * next opens, and arrives unassigned.
   *
   * @generated from rpc console.admin.v1.DeviceService.DeleteDevice
   */
  deleteDevice: {
    methodKind: "unary";
    input: typeof DeleteDeviceRequestSchema;
    output: typeof DeleteDeviceResponseSchema;
  },
  /**
   * The organization's own name for one of its devices: its administrators,
   * or MotionSafe staff. Empty clears it.
   *
   * @generated from rpc console.admin.v1.DeviceService.SetDeviceLabel
   */
  setDeviceLabel: {
    methodKind: "unary";
    input: typeof SetDeviceLabelRequestSchema;
    output: typeof SetDeviceLabelResponseSchema;
  },
  /**
   * MotionSafe staff only. MotionSafe's own name for a device, which no
   * organization sees. Empty clears it.
   *
   * SetDeviceMtls is gone: every device uses mutual TLS (ARCHITECTURE.md
   * §8.1.2).
   *
   * @generated from rpc console.admin.v1.DeviceService.SetDeviceStaffLabel
   */
  setDeviceStaffLabel: {
    methodKind: "unary";
    input: typeof SetDeviceStaffLabelRequestSchema;
    output: typeof SetDeviceStaffLabelResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_device, 0);

